import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiAvailState.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import { ApiBaseDataFromJSON, ApiBaseDataToJSON } from './ApiBaseData.js';
import './ApiBaseDataSource.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import { ApiCamperFeatureFromJSON, ApiCamperFeatureToJSON } from './ApiCamperFeature.js';
import './ApiCamperFeatureType.js';
import { ApiCamperRateFromJSON, ApiCamperRateToJSON } from './ApiCamperRate.js';
import { ApiCamperStationFromJSON, ApiCamperStationToJSON } from './ApiCamperStation.js';
import './ApiClientType.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import './ApiGender.js';
import './ApiImageType.js';
import './ApiInventory.js';
import { ApiItemFromJSONTyped, ApiItemToJSON } from './ApiItem.js';
import './ApiItemType.js';
import { ApiMediaFromJSON, ApiMediaToJSON } from './ApiMedia.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiCamperFromJSON(json) {
    return ApiCamperFromJSONTyped(json, false);
}
function ApiCamperFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ApiItemFromJSONTyped(json, ignoreDiscriminator),
        'serviceId': json['serviceId'],
        'pickupDate': (json['pickupDate']),
        'dropoffDate': (json['dropoffDate']),
        'pickupStation': ApiCamperStationFromJSON(json['pickupStation']),
        'dropoffStation': ApiCamperStationFromJSON(json['dropoffStation']),
        'vehicle': ApiBaseDataFromJSON(json['vehicle']),
        'supplier': ApiBaseDataFromJSON(json['supplier']),
        'beds': !exists(json, 'beds') ? undefined : json['beds'],
        'features': !exists(json, 'features') ? undefined : (json['features'].map(ApiCamperFeatureFromJSON)),
        'rates': !exists(json, 'rates') ? undefined : (json['rates'].map(ApiCamperRateFromJSON)),
        'media': !exists(json, 'media') ? undefined : ApiMediaFromJSON(json['media']),
        'status': json['status'],
        'minDriverAge': json['minDriverAge'],
        'maxChild': json['maxChild'],
        'minChild': json['minChild'],
        'maxAdults': json['maxAdults'],
        'minAdults': json['minAdults'],
        'maxPax': json['maxPax'],
        'minPax': json['minPax'],
    };
}
function ApiCamperToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ApiItemToJSON(value),
        'serviceId': value.serviceId,
        'pickupDate': (value.pickupDate),
        'dropoffDate': (value.dropoffDate),
        'pickupStation': ApiCamperStationToJSON(value.pickupStation),
        'dropoffStation': ApiCamperStationToJSON(value.dropoffStation),
        'vehicle': ApiBaseDataToJSON(value.vehicle),
        'supplier': ApiBaseDataToJSON(value.supplier),
        'beds': value.beds,
        'features': value.features === undefined ? undefined : (value.features.map(ApiCamperFeatureToJSON)),
        'rates': value.rates === undefined ? undefined : (value.rates.map(ApiCamperRateToJSON)),
        'media': ApiMediaToJSON(value.media),
        'status': value.status,
        'minDriverAge': value.minDriverAge,
        'maxChild': value.maxChild,
        'minChild': value.minChild,
        'maxAdults': value.maxAdults,
        'minAdults': value.minAdults,
        'maxPax': value.maxPax,
        'minPax': value.minPax,
    };
}

export { ApiCamperFromJSON, ApiCamperFromJSONTyped, ApiCamperToJSON };
//# sourceMappingURL=ApiCamper.js.map
